import { render, staticRenderFns } from "./m-orm-delete-dialog.vue?vue&type=template&id=ff09ec50&lang=pug&"
import script from "./m-orm-delete-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-delete-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-delete-dialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
